import script from "./videoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./videoSection.vue?vue&type=script&setup=true&lang=js"

import "./videoSection.vue?vue&type=style&index=0&id=10a005d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a005d5"]])

export default __exports__